import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import WithImpressions from '../../WithImpressions';
import { biHelper } from '../biHelper';
import Description from './Description';
import Languages from './Languages';
import SkillTests from './SkillTests';
import LinkedAccounts from './LinkedAccounts';
import Skills from './Skills';
import ProfessionalPresence from './ProfessionalPresence';
import SocialPresence from './SocialPresence';
import EducationList from './EducationList';
import Certifications from './Certifications';
import Appearances from './Appearances';
import Clients from './Clients';

import './index.scss';

export default function SellerProfile({
    description, languages, skillTests,
    identities, skills, professional_presences,
    online_presences, educations, certifications,
    appearances, clients, biData
}) {
    const seller_card_about_me_component = biHelper({
        ...biData,
        group: 'seller_card_about_me_component_impression'
    });

    let position = biData.initialCounter;

    return (
        <WithImpressions className="seller-profile" value={seller_card_about_me_component}>

            <Description position={description && position++}
                description={description} biData={{...biData, position}}/>

            <Languages position={!_.isEmpty(languages) && position++}
                languages={languages} biData={{...biData, position}}/>

            <SkillTests position={!_.isEmpty(skillTests) && position++}
                tests={skillTests} biData={{...biData, position}}/>

            <LinkedAccounts position={!_.isEmpty(identities) && position++}
                socialAccounts={identities} biData={{...biData, position}}/>

            <Skills position={!_.isEmpty(skills) && position++}
                skills={skills} biData={{...biData, position}}/>

            <ProfessionalPresence position={!_.isEmpty(professional_presences) && position++}
                professionalPresence={professional_presences} biData={{...biData, position}}/>

            <SocialPresence position={!_.isEmpty(online_presences) && position++}
                socialPresence={online_presences} biData={{...biData, position}}/>

            <EducationList position={!_.isEmpty(educations) && position++}
                educations={educations} biData={{...biData, position}}/>

            <Certifications position={!_.isEmpty(certifications) && position++}
                certifications={certifications} biData={{...biData, position}}/>

            <Appearances position={!_.isEmpty(appearances) && position++}
                appearances={appearances} biData={{...biData, position}}/>

            <Clients position={!_.isEmpty(clients) && position++}
                clients={clients} biData={{...biData, position}}/>

        </WithImpressions>
    );
}

SellerProfile.propTypes = {
    description: PropTypes.string,
    languages: PropTypes.array,
    identities: PropTypes.array,
    skills: PropTypes.array,
    professional_presences: PropTypes.array,
    online_presences: PropTypes.array,
    educations: PropTypes.array,
    certifications: PropTypes.array,
    appearances: PropTypes.array,
    clients: PropTypes.array,
    biData: PropTypes.shape({
        sellerId: PropTypes.number,
        buyerId: PropTypes.number,
        pageCtxId: PropTypes.string,
        initialCounter: PropTypes.number
    })
};

SellerProfile.defaultProps = {
    description: '',
    languages: [],
    identities: [],
    skills: [],
    professional_presences: [],
    online_presences: [],
    educations: [],
    certifications: [],
    appearances: [],
    clients: [],
    biData: {
        initialCounter: 0
    }
};
